import React, { useMemo } from "react";
import { Chip, Tooltip } from "@mui/material";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import { resolveClientRelationshipBadgeSummary } from "../../utils/clientRelationships";

const chipSx = {
  height: 20,
  maxWidth: 200,
  color: "text.secondary",
  borderColor: "divider",
  bgcolor: "transparent",
  fontWeight: 500,
  fontSize: "0.68rem",
  "& .MuiChip-icon": {
    fontSize: 14,
    ml: 0.5,
    color: "text.secondary",
  },
  "& .MuiChip-label": {
    px: 0.6,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

/**
 * Indicador discreto de relacionamentos do cliente (lista / header do chat).
 * Em B2B (PF ↔ PJ), prioriza o nome da empresa no label.
 */
export default function ClientRelationshipBadge({
  count = 0,
  relationships = null,
  clientId = null,
  hint = null,
  compact = false,
  sx,
}) {
  const summary = useMemo(
    () =>
      resolveClientRelationshipBadgeSummary({
        relationships,
        clientId,
        count,
        hint,
        compact,
      }),
    [relationships, clientId, count, hint, compact]
  );

  if (!summary) return null;

  const Icon = summary.prefersCompany ? BusinessOutlinedIcon : PeopleOutlineIcon;

  return (
    <Tooltip
      title={<span style={{ whiteSpace: "pre-line" }}>{summary.tooltip}</span>}
      placement="top"
      arrow
    >
      <Chip
        size="small"
        variant="outlined"
        icon={<Icon />}
        label={summary.label}
        aria-label={summary.tooltip}
        sx={{ ...chipSx, ...sx }}
      />
    </Tooltip>
  );
}
